// extracted by mini-css-extract-plugin
export default {"root":"FullscreenCentered_root__sLqxl"};